<template>
    <div class="com-famous-comment-item dsp-flex">
        <div class="com-famous-ci-avatar">
            <img class="com-famous-ci-img" v-bind:src="itemData.userAvatar == '' ? avatarUrl : itemData.userAvatar" alt="">
        </div>
        <div class="com-famous-ci-content">
            <div class="com-famous-cic-title">
                <span class="com-famous-cic-nickname">{{itemData.userName}}</span>
                <span v-if="!itemData.isDelete" class="com-famous-cic-good-2" @click.passive="clickLike">
                    <span v-if="itemData.likeNum != 0" class="com-famous-cic-good-num">{{itemData.likeNum}}</span><i class="iconfont" v-bind:class="{'icon-good2':itemData.isLike == 1, 'icon-good3':itemData.isLike == 0}"></i>
                </span>
                <span v-if="!itemData.isDelete" class="com-famous-cic-comment" @click="clickReply">
                    <i class="iconfont icon-comment-1"></i>
                </span>
            </div>
            <div v-if="itemData.isDelete" class="com-famous-cic-content-delete">
                <p>该评论已删除</p>
            </div>
            <div v-else class="com-famous-cic-content" @click.stop="clickCommentItem">
                <p v-html="UTILS.getBreakLineByText(itemData.msg)"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
export default {
    name: 'FamousCommentItem',
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return null }
        },
        operateFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            avatarUrl: require('../../assets/images/avatar.png'),
        }
    },
    methods: {
        clickCommentItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc('like', this.itemData)
            }
        },
        clickLike() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('like', this.itemData)
            }
        },
        clickReply() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('reply', this.itemData)
            }
        }
    }
}
</script>